/**
 * 本项目通用方法
 */

/**
 * 复制文本到剪切板
 * @param {String} text
 */
async function setClipboardData(text) {
  let val = String(text)
  if (navigator.clipboard && navigator.permissions) {
    return await navigator.clipboard.writeText(val)
  } else {
    // 兼容旧浏览器
    const textArea = document.createElement('textArea')
    textArea.value = val
    textArea.style.width = 0
    // 解决 Safari 浏览器中，点击复制按钮，整个页面会跳动一下
    textArea.style.position = 'fixed'
    textArea.style.left = 0
    textArea.style.top = 0
    textArea.style.transform = 'translate(-100%, -100%)'
    textArea.setAttribute('readonly', 'readonly')
    document.body.appendChild(textArea)
    textArea.select()
    let result = document.execCommand('copy')
    document.body.removeChild(textArea)
    if (!result) {
      throw new Error('复制失败')
    }
  }
}

/**
 * 得到一个唯一 id
 */
const getUniqueId = (function() {
  let id = 0
  return function() {
    return (
      Math.random()
        .toString(36)
        .substr(3, 3) + Number(`${Date.now()}${++id}`).toString(36)
    )
  }
})()

/**
 * 文件预览（支持 Excel、Word、PPT、图片等）
 * 此方法借助了第三方网站，打开新窗口预览（也可以使用 iframe 嵌套在当前页面）
 * 注意：重要文件不可使用该方法！！！存在安全泄密问题！！！使用前请三思
 */
function previewFile(url) {
  const newUrl = url.split('?')[0]
  const etc = newUrl.slice(newUrl.lastIndexOf('.') + 1)
  let openUrl = ''
  if (['pptx', 'ppt', 'xlsx', 'xls', 'doc', 'docx'].includes(etc)) {
    // word官方预览链接（支持三种格式，部分word带特殊符号或流程图无法显示）
    // openUrl = `https://view.xdocin.com/view?src=${encodeURIComponent(url)}`
    // office官方预览（pdf不能展示）
    openUrl = `http://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`
  } else {
    openUrl = url
  }
  window.open(openUrl, '_blank')
}

/**
 * 城市名规范化
 * 处理后端返回的特殊格式（如直辖市 "X市市辖区"），高德 setCity 无法直接解析这类名称
 * @param {string} city 城市名
 * @returns {string} 规范化后的城市名
 */
function normalizeCityName(city) {
  if (!city) return ''
  if (typeof city !== 'string') return String(city)
  const trimmed = city.trim()
  if (!trimmed) return ''
  // "北京市市辖区" → "北京"，"上海市市辖区" → "上海"（直辖市的市辖区格式）
  const m = trimmed.match(/^(.+)市市辖区$/)
  if (m) return m[1]
  return trimmed
}

export {
  // 复制文本到剪切板
  setClipboardData,
  // 得到一个唯一 id
  getUniqueId,
  // 文件预览（支持 Excel、Word、PPT、图片等）
  previewFile,
  // 城市名规范化
  normalizeCityName
}
